import { createAsyncThunk } from "@reduxjs/toolkit";

import coreAPIs from "../../../services/api/core";

export const listContentImages = createAsyncThunk("core/contentImage/listContentImages", async (payload) => {
  try {
    const response = await coreAPIs.listContentImages(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const generateContentImage = createAsyncThunk("core/contentImage/generateContentImage", async (payload) => {
  try {
    const response = await coreAPIs.generateContentImage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const deleteContentImages = createAsyncThunk("core/contentImage/deleteContentImages", async (payload) => {
  try {
    const response = await coreAPIs.deleteContentImages(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const updateContentImage = createAsyncThunk("core/contentImage/updateContentImage", async (payload) => {
  try {
    const response = await coreAPIs.updateContentImage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});
